<template>
  <div class="cSelectPopup-container">
    <f7-actions
      ref="openActions"
      :closeByBackdropClick="false"
      class="cSelectPopup-action"
      :opened="show"
    >
      <div class="cSelectPopup-main">
        <div class="cSelectPopup-header">
          <div class="headerline"></div>
          <div class="headername">
            <p>{{ showLoading ? '結果検索中...' : title + '検索' }}</p>
            <div class="img-box" @click="handleClose">
              <img src="../../assets/icon/close.svg" alt="" />
            </div>
          </div>
          <div class="cSelectPopup-inputbox">
            <img src="../../assets/icon/search.svg" alt />
            <input
              type="text"
              ref="inputname"
              v-model.trim="searchText"
              :placeholder="title + 'を入力してください'"
            />
            <img
              @click="handleClear"
              class="delete-icon"
              src="../../assets/icon/delete_white.svg"
            />
          </div>
        </div>
        <div class="cSelectPopup-contant">
          <div class="cSelect-box">
            <f7-list>
              <f7-list-item
                v-for="(item, index) in searchDatas"
                :title="item.value"
                :key="index"
                @click="handleCheck(item)"
              >
                <f7-icon>
                  <img src="../../assets/icon/add.svg" alt />
                </f7-icon>
              </f7-list-item>
            </f7-list>
          </div>
        </div>
      </div>
    </f7-actions>
  </div>
</template>

<script>
export default {
  props: ['show', 'title', 'searchDatas', 'showLoading', 'value'],
  data() {
    return {
      searchText: this.value,
      timer: ''
    };
  },
  watch: {
    searchText(val, oldval) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (val) {
        this.timer = setTimeout(() => {
          this.getSearchData();
        }, 300);
      }
    }
  },
  created() {},
  methods: {
    // 清除输入框
    handleClear() {
      this.searchText = '';
      this.$emit('handleClear');
    },
    // 没有选择时关闭
    handleClose() {
      this.$emit('handleClose');
    },
    // 父级点击搜索就会触发
    handelSelect(text) {
      this.searchText = text;
      if (text) {
        this.timer = setTimeout(() => {
          this.getSearchData();
        }, 300);
      }
    },
    // 搜索
    getSearchData() {
      this.$emit('getSearchData', this.searchText);
    },
    // 选择数据
    handleCheck(item) {
      this.$emit('handleCheck', item);
    }
  }
};
</script>

<style lang="less" scoped>
.imgSize(@width,@height) {
  width: @width;
  height: @height;
}
.cSelectPopup-action {
  height: 100%;
  padding-top: 0.47rem;
  position: fixed;
}
.cSelectPopup-main {
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-top-left-radius: 0.12rem;
  border-top-right-radius: 0.12rem;
  padding-top: 0.06rem;
  text-align: center;
  .cSelectPopup-header {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    padding-bottom: 0.16rem;
    .headerline {
      width: 40px;
      height: 4px;
      background: #e0e0e0;
      border-radius: 2px;
      margin: 0 auto;
    }
    .headername {
      font-size: 0.18rem;
      font-weight: 550;
      color: #222222;
      margin-top: 0.15rem;
      height: 0.27rem;
      position: relative;
      .img-box {
        height: 0.45rem;
        width: 0.8rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0rem;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      img {
        width: 0.14rem;
        height: 0.14rem;
        margin-left: 0.43rem;
      }
    }
    .cSelectPopup-inputbox {
      margin: 0.24rem 0.16rem 0 0.16rem;
      display: flex;
      align-items: center;
      border-radius: 0.2rem;
      padding: 0 0.2rem;
      font-size: 0.14rem;
      background-color: #f5f5f5;
      img {
        .imgSize(0.15rem, 0.15rem);
      }
      .delete-icon {
        .imgSize(0.2rem, 0.2rem);
        background-color: #8f8f8f;
        border-radius: 50%;
        padding: 0.05rem;
      }
      input {
        font-size: 0.14rem;
        flex: 1;
        margin-left: 0.1rem;
        height: 0.44rem;
      }
      input::-webkit-input-placeholder {
        font-family: Helvetica;
        color: #a3a3a3;
        font-size: 0.14rem;
        font-weight: 550;
      }
    }
  }
  .cSelectPopup-contant {
    overflow-y: scroll;
    .list {
      margin: 0;
    }
    .list ul:before {
      background: #fff;
    }
    .list .item-content {
      padding-left: 0;
    }
    .list .item-inner {
      padding-left: 0.2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Select/cSearchPopup.vue